import { makeStyles } from 'tss-react/mui';

const name = 'SecondaryTabs';

export const useSecondaryTabsStyles = makeStyles({ name })(theme => ({
  secondaryTabs: {
    display: 'inline-flex',

    width: 'auto',

    border: `2px solid ${theme.palette.background.default}`,
    borderRadius: 8, // ex 14

    background: theme.palette.surface.tertiary,
  },
}));
